import React, { Component } from "react";
import NewsItems from "./NewsItems";
export default class News extends Component {
  static defaultProps = {
    pageSize: 6,
    category: "general",
  };
    constructor(props) {
    super(props);
    this.state = {
      articles: [],
      loading: false,
      page: 1,
      totalResults: 0,
    };
  }
  updateNews = async () => {
    this.setState({ loading: true });
    const { page } = this.state;
    const { pageSize, category } = this.props;
    const url = `https://newsapi.org/v2/top-headlines?country=us&category=${category}&page=${page}&pageSize=${pageSize}&apiKey=83076a4c01984362996b1539c9b78840`;
    const response = await fetch(url);
    const data = await response.json();
    this.setState({
      articles: data.articles || [],
      totalResults: data.totalResults || 0,
      loading: false,
    });
  };
  async componentDidMount() {
    await this.updateNews();
  }
  async componentDidUpdate(prevProps) {
    if (prevProps.category !== this.props.category) {
      await this.setState({ page: 1 });
      this.updateNews();
    }
  }
  handlePrevClick = async () => {
    await this.setState((prev) => ({
      page: prev.page - 1,
    }));
    this.updateNews();
  };
  handleNextClick = async () => {
    await this.setState((prev) => ({
      page: prev.page + 1,
    }));
    this.updateNews();
  };
  render() {
    const totalPages = Math.ceil(
      this.state.totalResults / this.props.pageSize
    );
    return (
      <div className="container my-3">
        <h2 className="text-center mb-4">
          NewsMonkey - {this.props.category.toUpperCase()}
        </h2>

        {this.state.loading && (
          <div className="text-center my-5">
            <div className="spinner-border text-dark" />
          </div>
        )}

        <div className="row">
          {!this.state.loading &&
            this.state.articles.map((el) => (
              <div className="col-md-6 col-lg-4 mb-4" key={el.url}>
                <NewsItems
                  title={el.title}
                  description={el.description}
                  imageUrl={el.urlToImage}
                  newsUrl={el.url}
                  author={el.author}
                  source={el.source.name}
                  publishedAt={el.publishedAt}
                />
              </div>
            ))}
        </div>

        <div className="d-flex justify-content-between my-4">
          <button
            disabled={this.state.page <= 1}
            className="btn btn-dark"
            onClick={this.handlePrevClick}
          >
            ← Previous
          </button>

          <button
            disabled={this.state.page >= totalPages}
            className="btn btn-dark"
            onClick={this.handleNextClick}
          >
            Next →
          </button>
        </div>
      </div>
    );
  }
}
